var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nullData"},[_c('img',{attrs:{"src":require("@/assets/imgs/tips/more.png"),"alt":""}}),_c('p',[_vm._v("无结果")])])
}]

export { render, staticRenderFns }